'use strict';

;(function($) {
    const $search = $('#tx-solr-search-form-pi-results');

    if($search.length) {
        const $searchField = $search.find('.tx-solr-q');
        const $resetButton = $search.find('#reset-search')

        const toggleResetButtonVisibility = () => {
            if($searchField.val().length) {
                $resetButton.show();
            } else {
                $resetButton.hide();
            }
        }

        toggleResetButtonVisibility();
        $searchField.keyup(toggleResetButtonVisibility);

        $resetButton.click(() => {
            $searchField.val('');
            $resetButton.hide();
        });
    }
}($));
